import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  format: {
    whiteSpace: 'pre-wrap',
  },
});
